var _clipPath;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-loading_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 6.477 6.478 2 12 2c1.364 0 2.693.274 3.923.8a1.616 1.616 0 01-1.265 2.97A6.75 6.75 0 0012 5.23 6.772 6.772 0 005.226 12 6.772 6.772 0 0012 18.77 6.772 6.772 0 0018.774 12 1.614 1.614 0 1122 12c0 5.523-4.478 10-10 10S2 17.523 2 12zm15.324-4.58a1.703 1.703 0 011.534-1.699l.174-.008c.472 0 .899.19 1.208.5.31.309.5.736.5 1.208 0 .471-.19.898-.5 1.207-.309.31-.736.5-1.208.5-.471 0-.898-.19-1.208-.5a1.702 1.702 0 01-.5-1.207z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    clipPath: "url(#logo-loading_svg__a)"
  }, /*#__PURE__*/React.createElement("div", {
    className: "logo-loading_svg__gradient-logo",
    style: {
      width: 24,
      height: 24,
      borderRadius: "50%",
      background: "conic-gradient(from 73.3deg at 50% 50%,#e4e7ec 0deg,#667085 144.37deg,#667085 360deg)"
    },
    xmlns: "http://www.w3.org/1999/xhtml"
  })));
}

export default SvgLogoLoading;